export default {
    list: [],
    edit: { planOrder: {}, planEditors: [], compareStoreys: [] },
    annotation: {}
};
